import { useEffect } from 'react';
import { useRouter } from '@tanstack/react-router';

/**
 * Корневой index — редирект на /dashboard, а тот дальше по правилу входа
 * (AK-898/AK-896, `router.tsx` → `DashboardEntry`): хозяйство → «Данные
 * хозяйства» или «Карта» по заполненности двойника, «Холдинг» → экран «Холдинг».
 * `?farm=` (присланная ссылка, UC-7) едет дальше как есть.
 * Логин/onboarding/tenant-suspended обрабатывается в AppShell + api.ts (см. 401 → /login).
 *
 * `replace`: «назад» с конечного экрана не должно возвращать на `/`, который
 * тут же отправит человека вперёд снова.
 */
export function HomePage({ farmSearch }: { farmSearch?: string } = {}) {
  const router = useRouter();
  useEffect(() => {
    void router.navigate({
      to: '/dashboard',
      search: farmSearch ? { farm: farmSearch } : {},
      replace: true,
    });
  }, [router, farmSearch]);
  return null;
}

export default HomePage;
